import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=7374bbf5&scoped=true&"
import script from "./Speed.vue?vue&type=script&lang=js&"
export * from "./Speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374bbf5",
  null
  
)

export default component.exports